var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 9.16663L9.1665 1.66663C9.82954 1.66663 10.4654 1.93002 10.9343 2.39886C11.4031 2.8677 11.6665 3.50358 11.6665 4.16663V7.49996H16.3832C16.6248 7.49722 16.8641 7.54705 17.0845 7.64597C17.3049 7.7449 17.5012 7.89057 17.6597 8.07289C17.8183 8.2552 17.9353 8.46981 18.0026 8.70184C18.07 8.93386 18.0861 9.17776 18.0498 9.41663L16.8998 16.9166C16.8396 17.314 16.6377 17.6763 16.3314 17.9366C16.0252 18.197 15.6351 18.3378 15.2332 18.3333H5.83317M5.83317 9.16663V18.3333M5.83317 9.16663H3.33317C2.89114 9.16663 2.46722 9.34222 2.15466 9.65478C1.8421 9.96734 1.6665 10.3913 1.6665 10.8333V16.6666C1.6665 17.1087 1.8421 17.5326 2.15466 17.8451C2.46722 18.1577 2.89114 18.3333 3.33317 18.3333H5.83317",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_1001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.a482e49d1f9b8aba79a427949660ac38.svg";
export { ForwardRef as ReactComponent };